module.exports = {
	"returnPolicy": {
		"returnsAccepted": "Exclusive: As a trade member, you have an additional 7 days to initiate your return. Fees and limitations apply.",
		"returnsNotAccepted": "Exclusive: As a trade member, you may initiate a return of this item within 7 days of delivery. Fees and limitations apply."
	},
	"returnPolicyModal": {
		"returnsAccepted": "Exclusive: As a trade member, you have an additional 7 days to return this item.",
		"returnsNotAccepted": "Exclusive: As a trade member, you may initiate a return of this item within 7 days of delivery."
	},
	"tradeResponsibility": {
		"body": "You are responsible for the unsubsidized cost of return shipping for this item, which may be significantly higher than the cost to have the item shipped to you. Your exclusive return period is valid only on shipments within the U.S. and a 10% restocking fee applies. ",
		"linkCTA": "Learn More",
		"link": "https://www.1stdibs.com/trade/returns/"
	},
	"title": "Return Policy",
	"buyerProtection": {
		"header": "Buyer Protection Guaranteed",
		"beforeLink": "All purchases made through our online checkout are covered by our ",
		"linkHref": "https://www.1stdibs.com/about/promise/",
		"linkCTA": "buyer protection program",
		"afterLink": ". Regardless of the dealer's return policy, we’re here to help in the unlikely event your purchase is damaged in transit or significantly not as described."
	},
	"meta": {
		"title": "Buyer Protection on 1stdibs"
	},
	"staticMarketing": {
		"banner": "Buyer Protection on 1stdibs",
		"bannerImgAttrs": {
			"src": "/static/images/buyers/buyerAssuranceBannerImage.jpg",
			"alt": "Buyer Assurance Banner"
		},
		"description": [
			"We know buying unique pieces online requires trust. Thanks to our buyer protection program, you can shop world’s most iconic pieces and signature works with confidence. As long as you order via the 1stdibs secure checkout, your purchase will be fully protected.",
			"In the unlikely event you make a purchase through our secure checkout and receive an item that is significantly not as described or has been damaged in transit, we want to make it right <a href='#details'>(see details)</a>. Please email <a href='mailto:support@1stdibs.com' target='_blank'>support@1stdibs.com</a> within 7 days of receiving your item to let us know there is a problem, and we will work with you and the dealer to reach the best possible resolution, whether that be arranging for a return, a full refund, or a repair with a trusted restorer.",
			"As a trade member, you may also return qualifying items under the returns program for the trade. <a href='/trade/returns/'>Learn more</a>."
		],
		"benefitsTitle": "The 1stdibs Promise: Shop With Confidence",
		"benefits": [
			{
				"name": "Buyer Protection",
				"description": "Guaranteed purchase protection when you check out on 1stdibs",
				"svgId": "buyer-assurance"
			},
			{
				"name": "Secure Online Transactions",
				"description": "Safe and secure payment through our checkout process",
				"svgId": "lock"
			},
			{
				"name": "Store-To-Door Shipping",
				"description": "Easy shipping around the world",
				"svgId": "truck-moving"
			},
			{
				"name": "Dedicated Customer Support",
				"description": "Timely answers to all your questions from our support specialists",
				"svgId": "customer-support"
			}
		]
	},
	"programDetails": [
		{
			"heading": "In order to qualify for our Buyer Protection Program, your purchase must meet the following criteria:",
			"details": [
				[
					"The order was placed online through our secure checkout",
					"The item was significantly not as described, damaged in transit or never arrived",
					"You reported the issue within 7 days of delivery date (or within 180 days of the purchase date if the item never arrived)"
				]
			]
		},
		{
			"heading": "The Buyer Protection Program does not apply if:",
			"details": [
				[
					"You are returning an accurately described item, outside of the dealer's stated return policy",
					"You elected to arrange your own shipping or pick the item up in person, and the item was damaged at pickup or during shipping",
					"You purchased the item directly from the dealer (e.g. in store) without using our secure checkout"
				]
			],
			"footer": [
				"For more detailed examples pertaining to buyer protection eligibility, please visit our <a href='https://support.1stdibs.com/s/article/Buyer-Protection-Guaranteed' target='_blank'>support center</a>."
			]
		}
	],
	"svgIcon": "buyer-assurance",
	"text": "Buyer Protection Guaranteed",
	"tooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/about/promise/' target='_blank'>View details.</a>"
	},
	"tradeTooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/trade/promise/' target='_blank'>View details.</a>"
	}
};


//////////////////
// WEBPACK FOOTER
// ./json/copy/buyerAssuranceTrade.json
// module id = 1201
// module chunks = 4 14